import { render, staticRenderFns } from "./ExceptionView.vue?vue&type=template&id=63b30fb5&lang=pug&"
import script from "./ExceptionView.vue?vue&type=script&lang=js&"
export * from "./ExceptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports